import type { MyBetsState } from '../../types/myBets';

const cashedOutSuccessfully = (
  state: MyBetsState,
  payload: { betId: string; cashedOutAmount: number }
): MyBetsState => ({
  ...state,
  cashedOut: { ...state.cashedOut, [payload.betId]: payload.cashedOutAmount }
});

export default cashedOutSuccessfully;
